module.exports = __webpack_public_path__ + "static/media/rainbow-trout.84125d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/rainbow-trout.png
// module id = 330
// module chunks = 0